import { Box } from '@mui/material'
import React from 'react'

const RegistrationLayout = ({
    children,
    sidebarTitle = null,
    isPwa = false,
    backroute = null,
    moduleKey = null,
    isHomePage = false,
    showHeader = true,
    showMenu,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center'}}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '1920px',
          position: 'relative',
        }}
      >
        <Box
            sx={{
                position: 'absolute',
                width: { xs:'650px' , md: '100%' },
                height: {
                    xs:  '100vh',
                    md: '100vh',
                    xl: '-webkit-fill-available',
                },
                display: 'block',
                top: {xs: '-60px', md: '-10px'},

                left: {xs: '-320px', md: '0'},
                borderRadius: '4px',
                transform: 'rotate(0deg)',
                opacity: { xs: 1, md: 0.5 },
                backgroundImage: {
                  xs: `url('https://d2djimvzddgguw.cloudfront.net/humbee-homepage-images/banner/hexagon-pattern.svg')`
                , md: `url('https://d2djimvzddgguw.cloudfront.net/Humbee-auth-flow/hex-desktop-pattern.svg')`
                },
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}
        />
        <Box    
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ position: 'relative', flexGrow: 1}}>{children}</Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RegistrationLayout